module.exports = __webpack_public_path__ + "img/solgan.097b089c.gif";